import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { Observable } from 'rxjs';
import { getAdminProperty, getExportMap } from '../../admin-store/admin.selectors';
import {
  ClearAdminPropertyExportMapAction,
  LoadAdminPropertyAction,
  LoadAdminPropertyExportMapAction, LoadAdminPropertyExportMapAsExcelAction,
} from '../../admin-store';
import { ActivatedRoute, Params } from '@angular/router';
import { Property } from '../../../property/shared/models';
import { ExportMap } from '../../shared/models';
import { CommOperation } from '../../../../shared/models';
import { AdminExportMapImportComponent } from '../../components/admin-export-map-import';
import { CommunicationStateComponent } from '../../../../shared/components/communication-state';

@Component({
  templateUrl: './admin-property-export-map.component.html',
  styleUrls: ['./admin-property-export-map.component.scss'],
  standalone: false
})

export class AdminPropertyExportMapComponent implements OnInit, OnDestroy {

  @ViewChild(AdminExportMapImportComponent) public importComponent: AdminExportMapImportComponent;
  @ViewChild('uploadState', { static: true }) public uploadCommunicationState: CommunicationStateComponent;

  property$: Observable<Property>;
  exportMap$: Observable<ExportMap>;
  propertyId: string;

  constructor(private store: Store<AppState>,
    private route: ActivatedRoute) {
    this.property$ = this.store.pipe(select(getAdminProperty));
    this.exportMap$ = this.store.pipe(select(getExportMap));
  }

  ngOnInit() {

    this.route.params.subscribe(
      (params: Params) => {
        this.propertyId = params['id'];
        this.store.dispatch(new LoadAdminPropertyAction(this.propertyId));
        this.store.dispatch(new LoadAdminPropertyExportMapAction(this.propertyId));
      }
    );
  }

  ngOnDestroy() {
    this.store.dispatch(new ClearAdminPropertyExportMapAction());
  }

  onExport() {
    this.store.dispatch(new LoadAdminPropertyExportMapAsExcelAction(this.propertyId));
  }

  onUploading() {
    // this.resetNotificationArea();
  }

  onUploaded(commOperation: CommOperation) {
    this.uploadCommunicationState.setCommOperation(commOperation);

    // TODO: Can we use the response (updated export map) from the import response and call LoanAdminPropetyExportMapSuccessAction()?
    this.store.dispatch(new LoadAdminPropertyExportMapAction(this.propertyId));
  }
}
